<template>
  <div class="row list-av-equipe">
    <div class="container-fluid">
      <h4 class="title">Minha Equipe <loading-spin :check="loading"> </loading-spin>  </h4>
      <small>Clique no colaborador para visualizar suas avaliações</small><br/><br/>
      <div class="row">
        <div class="col-lg-12 col-md-12" v-for="collaborator in collaborators" :key="`collaborator-ev-${collaborator.id}`">
          <div class="card">
            <div class="card-content desc_member">
              <div class="row text-center collaborator_open" @click="openCollaborator(collaborator.id)">
                <div class="col-md-2 col-xs-4">
                  <div class="avatar img_member"><img :src="collaborator.avatar_url" alt="IMG COLAB" class="img-circle img-no-padding img-responsive"></div>
                </div>
                <div class="col-md-6 col-xs-8">
                  <div class="pull-left name_member">
                    <span>
                      {{ collaborator.name }}
                    </span><br/><small>{{ collaborator.position.name }}</small>
                  </div>
                </div>  
                <div class="col-md-4 col-xs-12">
                  <div class="pull-right">
                    <span class="label btn-status" :class="getClassLabel(collaborator.evaluation_status.label)">{{ collaborator.evaluation_status.name }}</span>
                  </div>
                </div>                
              </div>
              <div class="row" style="margin-top: 10px;" v-if="!!collaborator.plan_evaluation">
                <div class="col-md-12">
                  <el-collapse>
                    <el-collapse-item :title="`PLANO DE AÇÃO - ${collaborator.plan_evaluation.cycle_year} | ${translateStatus(collaborator.plan_evaluation.status)}`" name="1">
                      <div style="font-size: 14px;">
                        <p><b>{{ collaborator.plan_evaluation.development_plan_name }}</b></p>
                        <hr>
                        <i class="ti-calendar"></i>&nbsp;&nbsp;<b>Data de Início: </b><span class="category">{{ collaborator.plan_evaluation.start_date | formatDateBr }}</span><br/>
                        <i class="ti-calendar"></i>&nbsp;&nbsp;<b>Data de Término: </b><span class="category">{{ collaborator.plan_evaluation.end_date | formatDateBr }}</span><br/><br/>
                        <i class="ti-ticket"></i>&nbsp;&nbsp;<b>Competência: </b><br>

                        <span v-for=" skill in collaborator.plan_evaluation.newSkills">
                          <u>{{ skill.skill && skill.skill.name ? skill.skill.name : skill.name }}</u><br/>
                             {{ skill.skill && skill.skill.description ? skill.skill.description : skill.description }}<br/><br/>
                        </span>                      
                        
                        <div v-if="collaborator.plan_evaluation.description">
                          <i class="ti-clipboard"></i>&nbsp;&nbsp;<b>Descrição: </b><br/>
                          <div class="category" style="text-align: justify;"> {{ collaborator.plan_evaluation.description }} </div><br/>
                        </div>

                        <div v-if="collaborator.plan_evaluation.action_plan_objective">
                          <i class="ti-star"></i>&nbsp;&nbsp;<b>Objetivo: </b><br/>
                          <div class="category" style="text-align: justify;"> {{ collaborator.plan_evaluation.action_plan_objective }} </div><br/>
                        </div>

                        <div v-if="collaborator.plan_evaluation.identified_improvement_areas">
                          <i class="ti-bookmark"></i>&nbsp;&nbsp;<b>Áreas de Melhoria: </b><br/>
                          <div class="category" style="text-align: justify;"> {{ collaborator.plan_evaluation.identified_improvement_areas }} </div><br/>
                        </div>

                        <div v-if="collaborator.plan_evaluation.action_plan_goals_old">
                          <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas: </b><br/>
                          <div class="category" style="text-align: justify;"> {{ collaborator.plan_evaluation.action_plan_goals_old }} </div><br/>
                        </div>

                        <div v-else-if="collaborator.plan_evaluation.action_plan_goals && collaborator.plan_evaluation.action_plan_goals.length != 0">
                          <i class="ti-check-box"></i>&nbsp;&nbsp;<b>Metas:</b><br/>

                          <div 
                            v-for="(goal, index) in collaborator.plan_evaluation.action_plan_goals" 
                            :key="goal.id" 
                            class="goal"
                            style="margin-top: 10px; margin-bottom: 15px;"
                          >
                            <!-- <div class="panel-heading">
                              <h6>Meta {{ index + 1 }}</h6>
                            </div> -->
                            <div class="goal-title">
                              <span class="dot">•</span>
                              <b>Meta {{ index + 1 }}</b>
                              <span>-</span>
                              <span>{{ translateStatus(goal.status) }}</span>
                              <span>-</span>
                              <span>{{ goal.progress }}%</span>
                            </div>

                            <div class="goal-body">
                              <!-- Barra de progresso -->
                              <div class="progress" style="margin-bottom: 10px; height: 5px;">
                                <div 
                                  class="progress-bar" 
                                  role="progressbar"
                                  :aria-valuenow="goal.progress"
                                  aria-valuemin="0" 
                                  aria-valuemax="100"
                                  :style="'width: ' + goal.progress + '%;'"
                                >
                                  <!-- {{ goal.progress }}% -->
                                </div>
                              </div>

                              <b>Descrição:</b> {{ goal.goal }}</br>
                              <b>Estratégia:</b> {{ goal.strategy }}</br>
                              <b>Prazo:</b> {{ formatDate(goal.due_date) }}
                              <!-- <p v-if="goal.due_date">
                              </p> -->
                            </div>
                          </div>
                        </div>

                        <div v-if="collaborator.plan_evaluation.strategies_to_reach_goals_old">
                          <i class="ti-list"></i>&nbsp;&nbsp;<b>Estratégias para Alcançar as Metas: </b><br/>
                          <div class="category" style="text-align: justify;"> {{ collaborator.plan_evaluation.strategies_to_reach_goals_old }} </div><br/>
                        </div>

                        <div v-if="collaborator.plan_evaluation.success_indicators && collaborator.plan_evaluation.success_indicators.length > 0">
                          <i class="ti-stats-up"></i>&nbsp;&nbsp;<b>Indicadores de Sucesso:</b><br/>
                          <div v-for=" successIndicator in collaborator.plan_evaluation.success_indicators">
                            <div style="text-align: justify;"> - {{ successIndicator.success_indicator.description }} </div>
                          </div><br/>
                        </div>

                        <div v-if="collaborator.plan_evaluation.monitoring_meetings && collaborator.plan_evaluation.monitoring_meetings.length > 0">
                          <i class="ti-timer"></i>&nbsp;&nbsp;<b>Acompanhamento:</b><br/>
                          <div style="text-align: justify;">
                            Próxima reunião: {{ formatNextMonitoring(collaborator.plan_evaluation.next_monitoring) }}
                          </div>

                          <!-- Histórico de reuniões passadas -->
                          <div style="margin-top: 20px;">
                            <i class="ti-agenda"></i>&nbsp;&nbsp;<b>Histórico de Reuniões:</b><br/>
  
                            <div v-if="getPastMeetings(collaborator) && getPastMeetings(collaborator).length > 0" class="carousel-wrapper">
                              <!-- Botão anterior -->
                              <button class="nav-button left" @click="prevMeeting(collaborator)" :disabled="currentMeetingIndex(collaborator.id) === 0"><i class="ti-angle-left"></i></button>
  
                              <!-- Card da reunião com transição -->
                              <transition :name="slideDirectionByCollaborator[collaborator.id]" mode="out-in">
                                <div class="carousel-card" :key="(currentPastMeeting(collaborator) && currentPastMeeting(collaborator).id) || 'no-id'">
                                  <b>Data:</b> {{ currentPastMeeting(collaborator) ? formatDate(currentPastMeeting(collaborator).date) : '' }}<br>
                                  <div v-if="currentPastMeeting(collaborator) && currentPastMeeting(collaborator).status === 2">
                                    <span>Reunião não realizada.</span>
                                  </div>
                                  <div v-else>
                                    <div v-for="(goalProgress, index) in currentPastMeeting(collaborator).goal_progresses">
                                      <div v-if="goalProgress.progress_change && goalProgress.progress_change > 0">
                                        <i class="ti-arrow-up"></i>
                                        <b>
                                          <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                          <span v-else>Meta:</span>
                                        </b>
                                        <span style="color: green;"> + {{ goalProgress.progress_change }}%</span>
                                        <span>{{ goalProgress.action_plan_goal.goal }}</span>
                                      </div>
                                      <div v-else-if="goalProgress.progress_change == 0">
                                        <b>
                                          <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                          <span v-else>Meta:</span>
                                        </b>
                                        <span> + {{ goalProgress.progress_change }}%</span>
                                        <span>{{ goalProgress.action_plan_goal.goal }}</span>
                                      </div>
                                      <div v-else>
                                        <i class="ti-arrow-down"></i>
                                        <b>
                                          <span v-if="goalProgress.action_plan_goal.deleted_at">Meta (excluída):</span>
                                          <span v-else>Meta:</span>
                                        </b>
                                        <span style="color: red;"> - {{ goalProgress.progress_change * (-1) }}%</span>
                                        <span>{{ goalProgress.action_plan_goal.goal }}</span>
                                      </div>
                                    </div>
                                    <b>Feedbacks:</b> {{ currentPastMeeting(collaborator) && currentPastMeeting(collaborator).feedbacks ? currentPastMeeting(collaborator).feedbacks : 'Sem feedbacks' }}<br>
                                  </div>
                                </div>
                              </transition>
  
                              <!-- Botão próximo -->
                              <button
                                class="nav-button right"
                                @click="nextMeeting(collaborator)"
                                :disabled="currentMeetingIndex(collaborator.id) >= getPastMeetings(collaborator).length - 1"
                              >
                                <i class="ti-angle-right"></i>
                              </button>
  
                              <!-- Indicadores -->
                              <div class="carousel-indicators">
                                <span
                                  v-for="(meeting, index) in getPastMeetings(collaborator)"
                                  :key="meeting.id"
                                  :class="['indicator-dot', { active: index === currentMeetingIndex(collaborator.id) }]"
                                  @click="goToMeeting(collaborator, index)"
                                ></span>
                              </div>
                            </div>
                            <div v-else style="text-align: justify;">
                              As reuniões de acompanhamento realizadas aparecerão aqui.
                            </div><br />
                          </div>
                        </div>
                        
                        <div v-else-if="collaborator.plan_evaluation.monitoring_frequencies.length > 0">
                          <i class="ti-timer"></i>&nbsp;&nbsp;<b>Frequência de Monitoramento:</b><br/>
                          <div v-for=" monitoringFrequency in collaborator.plan_evaluation.monitoring_frequencies">
                            <div style="text-align: justify;"> - {{ monitoringFrequency.monitoring_frequency.description }} </div>
                          </div><br/>
                        </div>

                      </div>
                    </el-collapse-item>
                  </el-collapse>                  
                </div>
              </div>            
            </div>
          </div>
        </div>
      </div>     
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import moment from 'moment'

  export default {
    mounted () {
      this.getCollaborators()
    },
    data () {
      return {
        loading: false,
        currentMeetingIndexByCollaborator: {},
        slideDirectionByCollaborator: {}
      }
    },
    filters: {
      formatDateBr (date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    methods: {
      async getCollaborators () {
        this.loading = true
        await this.$store.dispatch('getCollaborators')
        .catch((error) => {
          console.log(error)
        })
        this.loading = false
      },
      openCollaborator (collaboratorId) {
        this.$router.push(`/avaliacao/equipe/perfil/${collaboratorId}`)
      },
      toEvaluate (evaluationId, collaboratorId) {
        swal({
          title: 'Você tem certeza!',
          text: 'Você iniciará avaliação agora.',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          preConfirm: res => {
            return this.verifyAccess(evaluationId).catch(error => {
              let message =
                'Não foi possível completa requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }

              swal.showValidationError(message)

              return new Promise((resolve, reject) => {
                reject(new Error(message))
              })
            })
          }
        }).then(res => {
          this.execEvaluation(res.data, collaboratorId)
        })
      },
      verifyAccess (evaluationId) {
        return axios.post('/collaborator/manager/verify-access-evaluation-me', {
          evaluation_id: evaluationId
        })
      },
      execEvaluation (dataAccess, collaboratorId) {
        swal({
          title: 'Acesso Liberado!',
          html:
            'Link de validação gerado. <br/> <small>Você tem 72 horas para realizar avaliação.</small>',
          type: 'success',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Acessar Avaliação',
          buttonsStyling: false,
          preConfirm: () => {
            if (dataAccess.access_token) {
              return new Promise((resolve, reject) => {
                resolve(dataAccess)
              })
            }

            return new Promise((resolve, reject) => {
              reject(new Error('Token não pode ser encontrado.'))
            })
          }
        })
          .then(res => {
            this.$router.push(`/avaliacao/formulario/${collaboratorId}/${res.access_token}`)
          })
          .catch(swal.noop)
      },
      getClassLabel (label) {
        let classLabel = ''

        switch (label) {
          case 'success':
            classLabel = 'label-success'
            break
          case 'warning':
            classLabel = 'label-warning'
            break
          case 'info':
            classLabel = 'label-info'
            break
          case 'danger':
            classLabel = 'label-danger'
            break
        }

        return classLabel
      },
      translateStatus (status) {
        const translations = {
          pending: 'Pendente',
          in_progress: 'Em Andamento',
          at_risk: 'Em Risco',
          completed: 'Concluído',
          overdue: 'Atrasado'
        }
        return translations[status] || status
      },
      formatNextMonitoring (nextMonitoring) {
        if (!nextMonitoring) {
          return 'NÃO AGENDADA'
        }
        const today = new Date()
        today.setHours(0, 0, 0, 0)

        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')

        const formattedToday = `${year}-${month}-${day}`

        if (nextMonitoring.date === formattedToday) {
          return 'HOJE'
        } else {
          return this.formatDate(nextMonitoring.date)
        }
      },
      formatDate (dateStr) {
        if (!dateStr) return ''

        // Extrair apenas a parte da data (YYYY-MM-DD)
        const [datePart] = dateStr.split(' ')
        const [year, month, day] = datePart.split('-').map(Number)

        // Criar a data corretamente no fuso local
        const date = new Date(year, month - 1, day)

        return date.toLocaleDateString('pt-BR')
      },
      getPastMeetings (collaborator) {
        return (collaborator.plan_evaluation.monitoring_meetings || [])
          .filter(m => m.status === 1 || m.status === 2)
          .sort((a, b) => new Date(a.date) - new Date(b.date))
      },
      currentMeetingIndex (collaboratorId) {
        return this.currentMeetingIndexByCollaborator[collaboratorId] || 0
      },
      currentPastMeeting (collaborator) {
        const meetings = this.getPastMeetings(collaborator)
        return meetings[this.currentMeetingIndex(collaborator.id)]
      },
      prevMeeting (collaborator) {
        const id = collaborator.id
        if (this.currentMeetingIndex(id) > 0) {
          this.slideDirectionByCollaborator[id] = 'slide-right'
          this.$set(this.currentMeetingIndexByCollaborator, id, this.currentMeetingIndex(id) - 1)
        }
      },
      nextMeeting (collaborator) {
        const id = collaborator.id
        const meetings = this.getPastMeetings(collaborator)
        if (this.currentMeetingIndex(id) < meetings.length - 1) {
          this.slideDirectionByCollaborator[id] = 'slide-left'
          this.$set(this.currentMeetingIndexByCollaborator, id, this.currentMeetingIndex(id) + 1)
        }
      },
      goToMeeting (collaborator, index) {
        const id = collaborator.id
        if (index !== this.currentMeetingIndex(id)) {
          this.slideDirectionByCollaborator[id] = index > this.currentMeetingIndex(id) ? 'slide-left' : 'slide-right'
          this.$set(this.currentMeetingIndexByCollaborator, id, index)
        }
      }
    },
    computed: {
      collaborators () {
        return this.$store.getters.collaborators
      }
    }
  }

</script>

<style scoped>
.slide-left-enter-active, .slide-left-leave-active,
.slide-right-enter-active, .slide-right-leave-active {
  transition: all 0.4s ease;
}

.slide-left-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-left-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.slide-right-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-right-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.carousel-wrapper {
  position: relative;
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 50px; /* espaço lateral pros botões */
}

.carousel-card {
  padding: 15px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: white;

  max-height: 300px;
  overflow-y: auto;
  width: 100%; /* ocupa o espaço entre os botões */
}

.nav-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 16px;
  cursor: pointer;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-button.left {
  left: 10px;
}

.nav-button.right {
  right: 10px;
}

.nav-button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

.nav-button:disabled:hover {
  background: inherit;
  color: inherit;
}

.carousel-indicators {
  /* position: absolute; */
  bottom: -30px; /* pode ajustar esse valor conforme necessário */
  display: flex;
  justify-content: center;
  gap: 8px;
}

.indicator-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ccc;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.indicator-dot.active {
  background-color: #409EFF;
}
</style>

<style>
  .collaborator_open {
    cursor: pointer;
  }

  .collaborator_open:hover .avatar img {
  -webkit-box-shadow: -2px 4px 5px 0px rgba(0,0,0,0.44);
    -moz-box-shadow: -2px 4px 5px 0px rgba(0,0,0,0.44);
    box-shadow: -2px 4px 5px 0px rgba(0,0,0,0.44);
  }
  .main-panel > .content {
      padding: 30px 15px 0 15px;
      min-height: calc(100% - 186px);
  }
  .label {
      padding: 8px 13px;
      border-radius: 30px;
  }
  .label-info {
    cursor: pointer;
  }
  .btn-status{
    font-size:1em !important;
  }
  .card .pull-right .btn-status {
    margin-top: 12px!important;
  }
  .date_evaluation{
    font-size:1em !important;
  }
  .card .card-content {
      padding: 8px 15px 12px 15px;
  }
  .swal2-modal .swal2-content {
      font-size: 15px;
  }
  .swal2-confirm{
    margin-right:10px;
  }
  .name_member {
    text-align:left;
  }
  .name_member small{
    opacity:0.7;
    margin-bottom:5px;
  }
  .goal {
    border-left: 2px solid #a4b1c1;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .goal-title {
    /* background-color: #f5f5f5; */
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    gap: 10px;
  }
  .goal-body {
    /* background-color: #f5f5f5; */
    padding-left: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Manager/Evaluation/Team/List.vue